import jQuery from "jquery";
(function (far, $) {
  far.datetime = {};

  //#region Public functions ====================================================

  far.datetime.initialize = function () {
    wireDateInputBoxes();
  };

  //#endregion

  //#region Private functions ===================================================

  function wireDateInputBoxes() {
    $(".js-date").pickadate({
      monthsFull: [
        "Januari",
        "Februari",
        "Mars",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "Augusti",
        "September",
        "Oktober",
        "November",
        "December",
      ],
      monthsShort: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec",
      ],
      weekdaysFull: [
        "söndag",
        "måndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "lördag",
      ],
      weekdaysShort: ["sön", "mån", "tis", "ons", "tor", "fre", "lör"],
      today: "Idag",
      clear: "Rensa",
      close: "Stäng",
      editable: true,
      firstDay: 1,
      format: "yyyy-mm-dd",
      labelMonthNext: "Nästa månad",
      labelMonthPrev: "Föregående månad",
      labelMonthSelect: "Välj månad",
      labelYearSelect: "Välj år",
    });

    // Lägg på mask för ÅÅÅÅ-MM-DD
    $(".js-date").mask("0000-M0-D0", {
      translation: { M: { pattern: /[0-1]/ }, D: { pattern: /[0-3]/ } },
    });

    $(".js-show-calendar").click(function (e) {
      e.stopPropagation();
      $(this).siblings(".js-date").first().pickadate("picker").open();
    });
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
